import React from 'react';
import { ChatPreset } from './types';

interface PresetButtonsProps {
  presets: ChatPreset[];
  loading: boolean;
  onPresetClick: (preset: ChatPreset) => void;
}

const PresetButtons: React.FC<PresetButtonsProps> = ({ presets, loading, onPresetClick }) => {
  return (
    <div className="mb-4">
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Quick analysis:</p>
      <div className="flex flex-wrap gap-2">
        {presets.map(preset => (
          <button
            key={preset.id}
            onClick={() => onPresetClick(preset)}
            disabled={loading}
            className="px-3 py-1.5 text-sm bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-700 rounded-full hover:bg-purple-100 dark:hover:bg-purple-900/40 transition-colors disabled:opacity-50"
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PresetButtons;
